import React, { useEffect } from 'react';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSelectedTabAtom } from '../../atoms/chat/useSelectedTabAtom';
import { useChatEnvironmentAtom } from '../../atoms/chat/useChatEnvironmentAtom';

import UserMenu from '../UserMenu';
import ChatComponent from './ChatComponent';
import ChatQuestions from './ChatQuestions';
import useCookie from '../../hooks/useCookie';
import useAuth from "../../hooks/useAuth";
import Tabs from './Tabs';

const ChatWindow = () => {

  const { auth } = useAuth();
  const [t, ] = useTranslation('global');
  const [envCookie, ] = useCookie("ENV");
  const [tabCookie, setTabCookie] = useCookie("TAB");
  const [selectedTab, setSelectedTab] = useSelectedTabAtom();
  const [, setChatEnvironmentId] = useChatEnvironmentAtom();

  const hasAccess = auth.uac && auth.uac.length > 0;

  const handleTabClick = debounce((intent) => {
    setSelectedTab(intent);
    setTabCookie("TAB", intent);
  },300);


  useEffect(() => {

    if (envCookie) {
      console.log(envCookie);
      setChatEnvironmentId(envCookie);
    } 

    if (tabCookie && tabCookie !== selectedTab) {
      setSelectedTab(tabCookie);
    } else if (!tabCookie) {
      setTabCookie("TAB", selectedTab);
      setSelectedTab(selectedTab);
    }
  }, []); 

  useEffect(()=>{
    if (tabCookie) {
      setSelectedTab(tabCookie);
    }
  },[tabCookie])

  return (
    <>  
    <ChatQuestions />
    <div id="msgerWindow" className="chat-wrapper">
    <section className="msger">
      <div className='msger-logo-wrapper'>
        <div className='msger-logo'>
          <div className="milladaTitle">
            Mi<span className="stripe-1">l</span>
            <span className="stripe-2">l</span>ada
          </div>
        </div>
        <header className="msger-header">
          <div className="msger-header-title">
            <UserMenu/>   
            <Tabs selectedTab={selectedTab} handleTabClick={handleTabClick}/>       
          </div>

          <div className="msger-header-options">
            <span>
              <i className="fas fa-cog"></i>
            </span>
          </div>          
        
        </header>
      </div>
      {hasAccess ? (
      <ChatComponent/>
      ) : (
        <div className='no-tab-access'>
          {t('noTabAccess')}
        </div>
      )}
    </section>
    </div>
    </>
  );
};

export default ChatWindow;
